import { render, staticRenderFns } from "./tracker-organizations-by-region-map-widget.vue?vue&type=template&id=cbb3638a&scoped=true&"
import script from "./tracker-organizations-by-region-map-widget.vue?vue&type=script&lang=js&"
export * from "./tracker-organizations-by-region-map-widget.vue?vue&type=script&lang=js&"
import style0 from "./tracker-organizations-by-region-map-widget.vue?vue&type=style&index=0&id=cbb3638a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb3638a",
  null
  
)

export default component.exports